// extracted by mini-css-extract-plugin
export default {"logo":"logo-SBMe","title":"title-pjN0"};